import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

Vue.filter('pluralize', (word, amount) => amount == 1 ? word : `${word}en`)

new Vue({
  render: h => h(App),
}).$mount('#app')
